import { Box } from "@chakra-ui/core";
import React from "react";

import ProfileNavigator from "../../../navigator/ProfileNavigator";

export const ProfilePage = () => {
  return (
    <Box px={["2", "20"]} py={["4", "4"]}>
      <ProfileNavigator />
    </Box>
  );
};
